<template>
  <NuxtLayout name="standard">
    <ConnectifTag :name="CONNECTIF_PAGE_TAGS.OTHERS" />
    <ConnectifTag :name="CONNECTIF_CONTENT_TAGS.OTHERS" />

    <div v-if="contactPageData" class="lg:mb-12">
      <TContainer>
        <TTitle tag="h1" size="4xl" classes="m-0">{{
          contactPageData.attributes.title
        }}</TTitle>
      </TContainer>
      <SContentFigures
        v-if="contentFigureItems && contentFigureItems.items.length > 0"
        v-bind="contentFigureItems"
      />
    </div>
  </NuxtLayout>
</template>

<script setup lang="ts">
// Constants
import {
  CONNECTIF_PAGE_TAGS,
  CONNECTIF_CONTENT_TAGS,
} from '~~/modules/integrations/connectif/constants'
import { sendConnectifPage } from '~~/modules/integrations/connectif/composables/useConnectifComposable'

// Types
import { type schemaType as contactPageSchematype } from '~~/modules/api/strapi/contact-page/schema'

// Composables
import { useHeadInfoComposable } from '~~/modules/head/composables/useHeadInfoComposable'

// Stores
import { useMenuBreadcrumbStore } from '~~/modules/menu/stores/useMenuBreadcrumbStore'

// Apis
import { serverFetch as getContactPageData } from '~~/modules/api/strapi/contact-page'

// Transformers
import { useToSContentFigures } from '~/composables/transformers/useToSContentFigures'

// Components Props
import type { propsInterface as SContentFigurePropsInterface } from '~~/modules/design-system/sections/s-content-figures.vue'

const { setHeadInfo } = useHeadInfoComposable()
const { fromStrapiContactPage } = useToSContentFigures()

const showErrorPage = (error: ApiResponseError) => {
  throw createError({
    statusCode: 503,
    message: error.message,
    fatal: true,
  })
}

const dataApiDetail = await getContactPageData()

let contactPageData: contactPageSchematype
const contentFigureItems: SContentFigurePropsInterface = {
  items: [],
}

if (dataApiDetail.success && dataApiDetail.success.data) {
  contactPageData = dataApiDetail.success.data

  if (contactPageData) {
    setHeadInfo({
      title: contactPageData.attributes.head.title,
      description: contactPageData?.attributes.head.description,
      images: [
        {
          url: contactPageData.attributes.head.image.data.attributes.url,
          alt: contactPageData.attributes.head.title,
        },
      ],
      robotsVisible: true,
    })

    const breadCrumbMenuStore = useMenuBreadcrumbStore()
    breadCrumbMenuStore.setMenuBreadcrumb(t('menu.breadcrumb.contact'))

    contentFigureItems.items = fromStrapiContactPage(contactPageData).items
  }
} else if (dataApiDetail.error) {
  showErrorPage(dataApiDetail.error as ApiResponseError)
}

sendConnectifPage()
</script>
